// extracted by mini-css-extract-plugin
module.exports = {"root__tall":"ReportEventRenderer_root__tall__7LYi0"};